import React from 'react';

const TOTAL_STEPS = 7;

const ProgressBar = ({ currentStep }) => {
  return (
    <div className="progress-bar">
      {Array.from({ length: TOTAL_STEPS }, (_, i) => (
        <div
          key={i}
          className={`progress-bar__dot${i < currentStep ? ' progress-bar__dot--active' : ''}`}
        />
      ))}
    </div>
  );
};

export default ProgressBar;
